import React, { useMemo, useState, useEffect } from "react";
import { MaterialReactTable } from 'material-react-table';
import { Button, IconButton, ListItemIcon, Tooltip, Grid, TextField, InputLabel, Autocomplete } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { AddCircleOutline, Close, FileDownload, Send, Toll } from "@mui/icons-material";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import AddTicket from "../components/modals/AddTicket";
import { styled } from '@mui/material/styles';
import Header from "../layouts/Header";
import { Link } from "react-router-dom";
import axios from 'axios';
import { instance } from "../utils/api";
import { DatePicker } from "@mui/x-date-pickers";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// import { ExportToCsv } from 'export-to-csv';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const cl = 'app-page-ticketlist';
// const data = [
//   {
//     ticketId: "#1111",
//     requestedBy: "John",
//     company: "Breative",
//     subject: "A possible solution would be to create a separate component for your row menu items.",
//     category: "payroll",
//     assignee: ['agent 1', 'agent 2', 'agent 3'],
//     priority: "high",
//     status: "open",
//     createdDate: "20-02-2023",
//     dueDate: "21-02-2023",

//   },
//   {
//     ticketId: "#1111",
//     requestedBy: "John",
//     company: "Breative",
//     subject: "A possible solution would be to create a separate component for your row menu items.",
//     assignee: ['agent 1'],
//     priority: "high",
//     category: "Recruitment",
//     status: "open",
//     createdDate: "20-02-2023",
//     dueDate: "21-02-2023",

//   },
// ];
const Spinner = () => (
  <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000 }}>
    <div style={{ width: '40px', height: '40px', borderRadius: '50%', border: '4px solid #ccc', borderTop: '4px solid rgb(255 122 0)', animation: 'spin 1s linear infinite' }}></div>
  </div>
);

const Priority = (props) => {
  const [priority, setPriority] = React.useState(props.initialPriority);
  const [ticketId, setTicketId] = React.useState(props.ticketId);
  const Token = localStorage.getItem("Token")
  const handleChange = (event) => {
    const newPriority = event.target.value;
    setPriority(newPriority);

    const updatedData = {
      priority: newPriority,
    };

    instance.put(`agents/ticket/${ticketId}`, updatedData, {headers: {
      'Accept': 'application/json',
      Authorization: `Bearer ${Token}`,
  }})
      .then((response) => {
        if (response.status === 200) {
          console.log("Ticket priority updated.");
          props.updatePriority(ticketId, newPriority);
        } else {
          console.error("Failed to update ticket priority.");
        }
      });
  };

  return (
    <FormControl fullWidth>
      <Select
        className={`proiority-select ${priority === 'high' ? '--high' : priority === 'medium' ? '--medium' : priority === 'low' ? '--low' : ""}`}
        id="demo-simple-select"
        value={priority}
        onChange={handleChange}
        displayEmpty
        size="small"
    
      >
       <MenuItem value='low'>Low</MenuItem>
        <MenuItem value='medium'>Medium</MenuItem>
        <MenuItem value='high'>High</MenuItem>
        <MenuItem value='urgent'>Urgent</MenuItem>
      </Select>
    </FormControl>
  )
}
const Status = (props) => {
  const [status, setStatus] = React.useState(props.initialStatus);
  const [ticketId, setTicketId] = React.useState(props.ticketId);
  const Token = localStorage.getItem("Token")
  const handleChange = (event) => {
    const newStatus = event.target.value;
    setStatus(newStatus);

    const updatedData = {
      status: newStatus,
    };

    instance.put(`agents/ticket/${ticketId}`, updatedData,
    {headers: {
      'Accept': 'application/json',
      Authorization: `Bearer ${Token}`,
  }})
      .then((response) => {
        if (response.status === 200) {
          console.log("Ticket status updated.");
          props.updateStatus(ticketId, newStatus);
        } else {
          console.error("Failed to update ticket status.");
        }
      });
  };
  return (
    <FormControl fullWidth>
      <Select
        id="demo-simple-select"
        value={status}
        displayEmpty
        onChange={handleChange}
        size="small"
        className={`proiority-select ${status === 'inprogress' ? '--inprogress' : status === 'onhold' ? '--onhold' : status === 'closed' ? '--closed' : ""}`}
      >
        <MenuItem value={'open'}>Open</MenuItem>
        <MenuItem value={'in progress'}>In Progress</MenuItem>
        <MenuItem value={'on hold'}>On Hold</MenuItem>
        <MenuItem value={'closed'}>Closed</MenuItem>
      </Select>
    </FormControl>
  )
}
const AddAssignee = (props) => {
  const { names, ticketId, agentsId,setTriggerRefresh} = props;
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const Token = localStorage.getItem("Token")
  const handleMenuClick = () => {
    const requestData = {
      assign_to: selectedAssignees,
      status: "open",
    };

    instance.put(`tickets/${ticketId}/assign`, requestData,
    {
      headers: {
        'Accept': 'application/json',
        Authorization: `Bearer ${Token}`,
    },
    }
    )
      .then((response) => {
        if (response.status === 202) { 

          console.log("Ticket assigned successfully.");
          setAnchorEl(null);
          setTriggerRefresh(prev => prev + 1)
        } else {
          console.error("Failed to assign the ticket.");
        }
      });
  };

  const handleCheckboxChange = (agentid) => {
    if (selectedAssignees.includes(agentid)) {
      setSelectedAssignees((prevAssignees) =>
        prevAssignees.filter((assignee) => assignee !== agentid)
      );
    } else {
      setSelectedAssignees((prevAssignees) => [...prevAssignees, agentid]);
    }
  };

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    setSelectedAssignees(props.selectedAssignees);
  }, [props.selectedAssignees]);

  return (
    <React.Fragment>
      <Tooltip title="Assign">
        <div className="table-assigne-add">
          <IconButton
            onClick={handleClick}
            className="table-assigne-add__addbtn"
          >
            <img src="/images/icons/add-user.svg" />
          </IconButton>
        </div>
      </Tooltip>
      <Menu
        id="card-actions-menu"
        anchorEl={anchorEl}
        className="add-assignee-menu"
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {agentsId.length === 0 ? (
          <MenuItem disabled>No agents available</MenuItem>
        ) : (
          agentsId.map((agentid) => {
            return (
              <MenuItem key={agentid}>
                <Checkbox
                  checked={selectedAssignees.includes(agentid)}
                  onChange={() => handleCheckboxChange(agentid)}
                />
                <ListItemText primary={names[agentsId.indexOf(agentid)]} />
              </MenuItem>
            );
          })
        )}
        <MenuItem className="assign-agent"onClick={handleMenuClick}>Assign</MenuItem>
      </Menu>
    </React.Fragment>
  );
};


const Duedate = (props) => {
  const [date, setDate] = React.useState(props.initialDate ? dayjs(props.initialDate) : null);
  const [ticketId, setTicketId] = React.useState(props.ticketId);
  const Token = localStorage.getItem("Token")
  const handleChange = (newDate) => {
    setDate(newDate);

    const updatedData = {
      due_date: newDate ? newDate.format("YYYY-MM-DD") : null,
    };

    instance.put(`agents/ticket/${ticketId}`, updatedData,{
      headers: {
        'Accept': 'application/json',
        Authorization: `Bearer ${Token}`,
    },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log("Due date updated.");
          props.updateDate(ticketId, newDate);
        } else {
          console.error("Failed to update due date.");
        }
      });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDatePicker
        className="ticket-duedate"
        value={date}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  );
}


// const csvOptions = {
//   fieldSeparator: ',',
//   quoteStrings: '"',
//   decimalSeparator: '.',
//   showLabels: true,
//   useBom: true,
//   useKeysAsHeaders: false,
//   headers: columns.map((c) => c.header),
// };
// const csvExporter = new ExportToCsv(csvOptions);





function TicketsList() {

  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [category, setCategory] = useState('');
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');
  const [assignee, setAssignee] = useState([]);
  const [priority, setPriority] = useState('');
  const [dueDate, setDueDate] = useState(null);
  const [ticketData, setTicketData] = useState([]);
  
  const [names, setNames] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  // const handleSaveTicket = async (formData) => {
  //   try {
  //     const response = await instance.post('tickets/create/', formData);

  //     if (response.status === 200) {
  //       console.log('Ticket added successfully');
  //       setTicketData([...ticketData, response.data]);

  //       handleClose();
  //     } else {
  //       console.error('Failed to add a ticket');
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //   }
  // };
  const [agentsId, setAgentsId] = useState([]);
  useEffect(() => {
    async function fetchAgentNames() {
      try {
        const response = await instance.get("agents/list");
        if (response.status === 200) {

          const agentData = response.data;
          const name = agentData.map((agent) => agent.name);
          setNames(name);
          const agentid=agentData.map((agent)=> agent.agent_id);
          setAgentsId(agentid)
          console.log({agentid})
          console.log({name })
        } else {
          console.error("Failed to fetch agent data");
        }
      } catch (error) {
        console.error("Network error:", error);
      }
    }
    fetchAgentNames();
  }, []);
  const handleSaveTicket = async (formData) => {
    try {
      const response = await instance.post('tickets/create/', formData);

      if (response.status === 200) {
        console.log('Ticket added successfully');
        setTicketData([...ticketData, response.data]);

        handleClose();
        setTriggerRefresh(prev => prev + 1); 
      } else {
        console.error('Failed to add a ticket');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    console.log(names);
  }, [names]);


  const [triggerRefresh, setTriggerRefresh] =React.useState(0)
  useEffect(() => {
    const fetchTicketData = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get(`tickets/list/`);

        if (response.status === 200) {
          console.log({ triggerRefresh })
          setTicketData(response.data);
         
          console.log('test', response.data)
       
        } else {
          console.error('Failed to fetch ticket data');
        }
      } catch (error) {
        console.error('Error:', error);
      }
      finally {

        setIsLoading(false);
      }
    };

    fetchTicketData();
  }, [triggerRefresh]);


  const updateTicket = async (ticketId, data) => {
    try {
      const response = await instance.put(`agents/ticket/${ticketId}`, data);

      if (response.status === 200) {
        console.log(`Ticket ${ticketId} updated successfully.`);
        return true;
      } else {
        console.error(`Failed to update ticket ${ticketId}`);
        return false;
      }
    } catch (error) {
      console.error('Error:', error);
      return false;
    }
  };

  const columns = [
    {
      accessor: "ticket_id",
      header: "ID",
      Cell: ({ row }) => (
        <Tooltip title={`View Ticket ${row.original.ticket_id}`}>
          <Link to={`/ticketdetail/${row.original.ticket_id}`}>
            <Button style={{ padding: "0", minWidth: 'auto' }} className="custom-table-cell-text">
              {row.original.ticket_id}
              {/* {console.log('rrrr',row)} */}
            </Button>
          </Link>
        </Tooltip>
      ),

      size: 50,
    },
    {
      accessor: "full_name",
      header: "Requested By",
      Cell: ({ row }) => <span className="custom-table-cell-text">{row.original.full_name}</span>
    },
    {
      accessor: "company",
      header: "Company",
      Cell: ({ row }) => <span className="custom-table-cell-text">{row.original.company}</span>
    },
    {
      accessor: "subject",
      header: "Subject",
      Cell: ({ row }) => <span className="custom-table-cell-text">{row.original.subject}</span>,
      size: 300,
    },
    {
      accessor: "help_topic",
      header: "Category",
      Cell: ({ row }) => <span className="custom-table-cell-text">{row.original.help_topic}</span>,
      size: 300,
    },
    {
      accessor: "assigned_agents",
      header: "Assignee",
      Cell: ({ row }) => (
        <>
          <div className="table-assigne">
            <ul className="table-assigne__list">
              {row.original.assigned_agents.rows.length > 0 ? (
                row.original.assigned_agents.rows.map((assignedAgent, index) => (
                  <li key={assignedAgent.agent_id} className="table-assigne__listitem">
                    <Tooltip title={assignedAgent.Agent.name}>
                    <div className="table-assigne-box">
  {assignedAgent.Agent.image ? ( 
    <img className="table-assigne-pic" src={assignedAgent.Agent.image} />
  ) : (
    <img className="table-assigne-pic" src="/images/icons/user.svg" /> 
  )}

  {index === row.original.assigned_agents.rows.length - 1 ? (
    <img src="/images/icons/remove.svg" className="table-assigne-remove" />
  ) : null}
</div>
                    </Tooltip>
                  </li>
                ))
              ) : null} 
              <li className="table-assigne__listitem">
                <AddAssignee ticketId={row.original.ticket_id} agentsId={agentsId} names={names} 
                 selectedAssignees={row.original.assigned_agents.rows.map(agent => agent.agent_id)} 
                 setTriggerRefresh={setTriggerRefresh}
                 />
              </li>
            </ul>
          </div>
        </>
      ),
    },
    {
      accessor: "priority",
      header: "Priority",
      Cell: ({ row }) => (
        <>
          <span hidden>{row.original.priority}</span>
          <Priority
            ticketId={row.original.ticket_id}
            initialPriority={row.original.priority} 
            updatePriority={(ticketId, newPriority) => {
              
            }}
          />
        </>
      )
    },
    {
      accessor: "status",
      header: "Status",
      Cell: ({ row }) => (
        <>
          <span hidden>{row.original.status}</span>
          <Status
            ticketId={row.original.ticket_id}
            initialStatus={row.original.status} 
            updateStatus={(ticketId, newStatus) => {
              
            }}
          />
        </>
      )
    },
    {
      accessor: "createdAt",
      header: "Created Date",
      Cell: ({ row }) => (
        <span className="custom-table-cell-text">
          {dayjs(row.original.createdAt).format("MM/DD/YYYY")}
        </span>
      ),
    },
    {
      accessor: "due_date",
      header: "Due Date",
      Cell: ({ row }) =>
      (<>
        <span hidden className="custom-table-cell-text">
          {dayjs(row.original.due_date).format("YYYY-MM-DD HH:mm:ss")}
        </span>
        <Duedate 
        ticketId={row.original.ticket_id}
        initialDate={row.original.due_date} 
        updateDate={(ticketId, newDate) => {
          
        }}/>
      </>
      )
    },
  ]
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="ticketlist" >
        <Header />
      </div>
      <div className='app-page-body'>
        <div className='app-page-wrapper'>
          <div className={`${cl}`}>
            <div className={`${cl}__header`}>
              <h2 className={`${cl}__header--title`}>Ticket List</h2>
              <ul className={`${cl}__header--actions`}>
                <li className={`${cl}__header--actionsitem`}>
                  <Button variant="contained" onClick={handleClickOpen}><AddCircleOutline /> Add Ticket</Button>
                </li>
              </ul>
            </div>
          </div>
          <div className="app-table-component">
          {isLoading ? (

<Spinner />
) : (
            <MaterialReactTable columns={columns} data={ticketData} enableRowActions
              renderRowActionMenuItems={({ closeMenu }) => [
                <MenuItem
                  key={0}
                  onClick={() => {
                    closeMenu();
                  }}
                  sx={{ m: 0 }}
                >
                  <ListItemIcon>
                    <Toll />
                  </ListItemIcon>
                  <span>View Ticket</span>
                </MenuItem>,
                // <MenuItem
                //   key={1}
                //   onClick={() => {
                //     closeMenu();
                //   }}
                //   sx={{ m: 0 }}
                // >
                //   <ListItemIcon>
                //     <Send />
                //   </ListItemIcon>
                //   <span>Send Email</span>
                // </MenuItem>,
              ]}
              positionActionsColumn="last"
              enablePinning
              positionToolbarAlertBanner="bottom"
              initialState={{ columnPinning: { left: ['ticket_id', 'subject'], } }}

            />
)}
          </div>
        </div>
      </div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Add Ticket
        </DialogTitle>
        <IconButton
          size="small"
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 10,
            top: 14,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
        <DialogContent dividers>
          <div>
            <AddTicket triggerRefresh={triggerRefresh} setTriggerRefresh={setTriggerRefresh} handleClose={handleClose} />

            {/* <div className={`${cl}`}>
              <div className={`${cl}__card`}>
                <Grid container spacing={3}>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          size="medium"
                          required
                          id="outlined-basic"
                          label="Name"
                          placeholder="Enter name"
                          type="text"
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField
                          value={company}
                          onChange={(e) => setCompany(e.target.value)}
                          id="outlined-basic"
                          label="Company"
                          placeholder="Enter company"
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          id="outlined-basic"
                          label="Email"
                          placeholder="Enter email"
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          id="outlined-basic"
                          label="Phone"
                          placeholder="Enter phone"
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={12}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Category</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={category}
                          label="Category"
                          onChange={(e) => setCategory(e.target.value)}
                        >
                          <MenuItem value={10}>Category 1</MenuItem>
                          <MenuItem value={20}>Category 2</MenuItem>
                          <MenuItem value={30}>Category 3</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={12}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField
                          value={subject}
                          onChange={(e) => setSubject(e.target.value)}
                          required
                          id="outlined-basic"
                          label="Subject"
                          placeholder="Enter subject"
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={12}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <TextField
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          id="outlined-basic"
                          label="Description"
                          multiline
                          rows={3}
                          placeholder="Enter description"
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={12}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <Autocomplete
                          id="grouped-demo"
                          multiple
                          // options={names}
                          value={assignee}
                          onChange={(e, newValue) => setAssignee(newValue)}
                          renderInput={(params) => <TextField placeholder="Select assignee" {...params} label="Assignee" />}
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Priority</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          value={priority}
                          onChange={(e) => setPriority(e.target.value)}
                          label="Priority"
                        >
                          <MenuItem disabled value=''>
                            <em>
                              Select Status
                            </em>
                          </MenuItem>
                          <MenuItem value={'normal'}>Normal</MenuItem>
                          <MenuItem value={'low'}>Low</MenuItem>
                          <MenuItem value={'medium'}>Medium</MenuItem>
                          <MenuItem value={'high'}>High</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                    <div className="app-form-fields">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <FormControl fullWidth>
                          <DatePicker
                            label="Due Date"
                            value={dueDate}
                            onChange={(date) => setDueDate(date)}
                          />
                        </FormControl>
                      </LocalizationProvider>
                    </div>
                  </Grid>
                  <DialogActions>
                    <Button type="primary" variant="contained" autoFocus onClick={handleSaveTicket}>
                      Save changes
                    </Button>
                  </DialogActions>
                </Grid>
              </div>
            </div> */}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <ToastContainer position="top-right" />
    </>
  )
}
export default TicketsList;
